import { User, Patient, HealthcareProvider, SuperAdmin, DemoUser } from '../types/users';

export const demoUsers: User[] = [
  // Demo Patient
  {
    id: 'demo-patient-1',
    email: 'demo.patient@healthtracker.com',
    firstName: 'Jane',
    lastName: 'Demo',
    role: 'demo',
    demoType: 'patient',
    createdAt: '2024-01-01T00:00:00Z',
    lastLoginAt: '2024-01-15T10:30:00Z',
    isActive: true,
    mfaEnabled: true,
    encryptionKeyId: 'key-demo-patient-1',
    blockchainAddress: '0x742d35Cc6609C7b2A1b4c1F4Bb1e8D4C5F6E7D8E',
    p2pNodeId: 'QmDemo1PatientNode123',
    expiresAt: '2024-12-31T23:59:59Z',
    limitations: ['Limited to 10 conditions', 'No data export', '30-day demo period']
  } as DemoUser,

  // Demo Healthcare Provider
  {
    id: 'demo-provider-1',
    email: 'demo.doctor@healthtracker.com',
    firstName: 'Dr. Michael',
    lastName: 'Demo',
    role: 'demo',
    demoType: 'provider',
    createdAt: '2024-01-01T00:00:00Z',
    lastLoginAt: '2024-01-15T14:20:00Z',
    isActive: true,
    mfaEnabled: true,
    encryptionKeyId: 'key-demo-provider-1',
    blockchainAddress: '0x123a45Bc6789D1e2F3g4H5i6J7k8L9m0N1o2P3q4',
    p2pNodeId: 'QmDemo1ProviderNode456',
    expiresAt: '2024-12-31T23:59:59Z',
    limitations: ['View-only access', 'Max 5 patients', '30-day demo period']
  } as DemoUser,

  // Super Admin
  {
    id: 'admin-1',
    email: 'admin@healthtracker.com',
    firstName: 'System',
    lastName: 'Administrator',
    role: 'super_admin',
    createdAt: '2024-01-01T00:00:00Z',
    lastLoginAt: '2024-01-15T09:00:00Z',
    isActive: true,
    mfaEnabled: true,
    encryptionKeyId: 'key-admin-1',
    blockchainAddress: '0xADMIN123456789ABCDEF0123456789ABCDEF0123',
    p2pNodeId: 'QmAdminNodeMaster789',
    permissions: {
      userManagement: true,
      systemConfiguration: true,
      encryptionKeyManagement: true,
      blockchainOperations: true,
      auditLogAccess: true,
      emergencyOverride: true,
    }
  } as SuperAdmin,

  // Sample Patient
  {
    id: 'patient-1',
    email: 'john.doe@example.com',
    firstName: 'John',
    lastName: 'Doe',
    role: 'patient',
    dateOfBirth: '1985-03-15',
    phoneNumber: '+1-555-123-4567',
    emergencyContact: 'Jane Doe - +1-555-987-6543',
    createdAt: '2024-01-01T00:00:00Z',
    lastLoginAt: '2024-01-15T10:30:00Z',
    isActive: true,
    mfaEnabled: true,
    encryptionKeyId: 'key-patient-1',
    blockchainAddress: '0x456b78Cd9012E3f4G5h6I7j8K9l0M1n2O3p4Q5r6',
    p2pNodeId: 'QmPatient1Node123ABC',
    preferredProviders: ['provider-1', 'provider-2'],
    dataStoragePreference: 'hybrid',
    shareableFields: {
      basicInfo: true,
      medicalConditions: true,
      medications: true,
      vitals: true,
      labResults: false,
      notes: false,
    },
    consentSettings: {
      researchParticipation: true,
      anonymizedDataSharing: true,
      marketingCommunications: false,
      emergencyAccess: true,
    }
  } as Patient,

  // Sample Healthcare Provider
  {
    id: 'provider-1',
    email: 'dr.smith@medicalcenter.com',
    firstName: 'Dr. Sarah',
    lastName: 'Smith',
    role: 'healthcare_provider',
    licenseNumber: 'MD-12345-CA',
    specialty: 'Endocrinology',
    institution: 'City Medical Center',
    createdAt: '2024-01-01T00:00:00Z',
    lastLoginAt: '2024-01-15T14:20:00Z',
    isActive: true,
    mfaEnabled: true,
    encryptionKeyId: 'key-provider-1',
    blockchainAddress: '0x789c01De2345F6g7H8i9J0k1L2m3N4o5P6q7R8s9',
    p2pNodeId: 'QmProvider1NodeDEF456',
    verificationStatus: 'verified',
    accessiblePatients: ['patient-1'],
    credentialHash: '0xabcdef123456789...' // Blockchain-verified medical license
  } as HealthcareProvider,
];

export const getCurrentUser = (userId: string): User | null => {
  return demoUsers.find(user => user.id === userId) || null;
};

export const getUsersByRole = (role: string): User[] => {
  return demoUsers.filter(user => user.role === role);
};